export const convertUnicode = (input) => {
    return input.replace(/\\u(\w\w\w\w)/g,function(a,b) {
        const charcode = parseInt(b,16);
        const char = String.fromCharCode(charcode);

        return char;
    });
};
  


// WEBPACK FOOTER //
// ./src/utils/string.js